const DynaCore_FormConfig_Miniform =
    {
        partClass: "el-miniform",
        partName: "miniform",
        partSelector: ".el-miniform",

        /**
         * Inicializace objektu typu Miniform
         */
        init: function() {
            DynaCore_FormConfig_Miniform.contextMenuInit();
            DynaCore_FormConfig_Miniform.contextMenuInitFields();
            DynaCore_FormConfig_Miniform.sortableInit();
        },

        contextMenuInit: function() {
            $("#designer")
                .off("contextmenu", DynaCore_FormConfig_Miniform.partSelector)
                .on("contextmenu", DynaCore_FormConfig_Miniform.partSelector, function(e) {
                    DynaCore_FormConfig_Miniform.contextMenuShow(e, this);
                    return false;
                });
        },

        contextMenuInitFields: function() {
            $("#designer").find(".el-miniform").each(function(i, elementPart) {
                const partId = $(elementPart).data("part-id");
                const elementFieldModalContainer = $(elementPart).find(".el-miniform-fieldModal-container");
                const elementFieldSectionContainer = $(elementPart).find(".el-miniform-fieldSection-container");

                DynaCore_FormConfig.fieldsInitContextMenuInline(elementFieldModalContainer, "miniforms", partId, "fieldsModal");
                DynaCore_FormConfig.fieldsInitContextMenuInline(elementFieldSectionContainer, "miniforms", partId, "fieldsSection");
            });
        },

        /**
         * Inicializace kontextoveho menu objektu typu Miniform
         *
         * @param e
         * @param element
         */
        contextMenuShow: function(e, element) {
            DynaBase_ContextMenu.addHeader(translate("Miniform"));

            // Tlacitko - Upravit
            DynaBase_ContextMenu.addButton(translate("Edit"), "pencil", function() {
                DynaCore_FormConfig_Miniform.edit(element);
            });

            DynaBase_ContextMenu.addDivider();
            DynaBase_ContextMenu.addHeader(translate("General"));

            // Vlastnosti
            DynaBase_ContextMenu.addButton(translate("Properties"), "toggle-on", function() {
                let storageId = $(element).data("part-id");

                DynaCore_FormConfig_Properties.edit(element, DynaCore_FormConfig_Miniform.partName + "s", storageId);
            });

            // Tlacitko - Nastaveni
            DynaBase_ContextMenu.addButton(translate("Settings"), "cog", function() {
                let storageId = $(element).data("part-id");

                DynaCore_FormConfig_Settings.edit(element, DynaCore_FormConfig_Miniform.partName + "s", storageId);
            });

            // Tlacitko - Odstranit
            DynaBase_ContextMenu.addButton(translate("Remove"), "trash", function() {
                DynaCore_FormConfig_Miniform.delete(element);
            });

            // Sestaveni
            DynaBase_ContextMenu.build(e, element);
        },

        /**
         * Inicializace razeni objektu typu Miniform
         */
        sortableInit: function() {
            let indexPartOld = 0;
            let indexPartNew = 0;

            $(".el-col").sortable({
                axis: "y",
                items: DynaCore_FormConfig_Miniform.partSelector,
                start: function(e, ui) {

                    // Najdeme si element rodice
                    let parentElement;
                    let cardElement = $(e.target).children(".card");
                    if ($(cardElement).length > 0) {
                        parentElement = $(cardElement).children(".card-body");
                    } else {
                        parentElement = e.target;
                    }

                    // Najdeme index
                    $(parentElement).find(DynaCore_FormConfig_Miniform.partSelector).each(function(i, el) {
                        if ($(el).is(ui.item)) {
                            indexPartOld = i;
                        }
                    });
                },
                update: function(e, ui) {

                    // Najdeme si element rodice
                    let parentElement;
                    let cardElement = $(e.target).children(".card");
                    if ($(cardElement).length > 0) {
                        parentElement = $(cardElement).children(".card-body");
                    } else {
                        parentElement = e.target;
                    }

                    // Najdeme index
                    $(parentElement).find(DynaCore_FormConfig_Miniform.partSelector).each(function(i, el) {
                        if ($(el).is(ui.item)) {
                            indexPartNew = i;
                        }
                    });

                    let data;
                    if (parseInt($(ui.item).data("tab")) >= 0) {
                        data = {
                            _ch: $("#_ch").val(),
                            pa: DynaCore_FormConfig_Miniform.partName,
                            r: $(ui.item).data("row"),
                            c: $(ui.item).data("col"),
                            t: $(ui.item).data("tab"),
                            tr: $(ui.item).data("tab-row"),
                            tc: $(ui.item).data("tabl-col"),
                            o: indexPartOld,
                            n: indexPartNew
                        };
                    } else {
                        data = {
                            _ch: $("#_ch").val(),
                            pa: DynaCore_FormConfig_Miniform.partName,
                            r: $(ui.item).data("row"),
                            c: $(ui.item).data("col"),
                            o: indexPartOld,
                            n: indexPartNew
                        };
                    }

                    $.ajax({
                        type: "get",
                        url: window.location.href.replace("/form-config/", "/form-config/part-sort/"),
                        data: data,
                        dataType: "json",
                        success: function() {
                            DynaCore_FormConfig.reindex();
                        }
                    });
                }
            });
        },

        /**
         * Pridani objektu typu Miniform
         *
         * @param element
         * @param elementParent
         * @returns {boolean}
         */
        add: function(element, elementParent) {
            let indexRow = $(elementParent).data("row");
            let indexCol = $(elementParent).data("col");
            let indexTab = $(elementParent).data("tab");
            let indexTabRow = $(elementParent).data("tab-row");
            let indexTabCol = $(elementParent).data("tab-col");
            let hasCard = $(elementParent).children().hasClass("el-col-card");

            if (true === hasCard) {
                elementParent = $(elementParent).children(".el-col-card").children(".card-body");
            }

            let partIndex = $(elementParent).children(DynaCore_FormConfig_Miniform.partSelector).length;
            let partCount = partIndex + 1;

            if (partCount > 1) {
                Lemo_Alert.addDanger("Column cannot contain more miniforms", "formConfigTooMuchMiniformsInColumnError");
                return false;
            }

            $.ajax({
                type: "get",
                url: window.location.href.replace("/form-config/", "/form-config/part-add/"),
                data: {
                    _ch: $("#_ch").val(),
                    pa: DynaCore_FormConfig_Miniform.partName,
                    r: indexRow,
                    c: indexCol,
                    t: indexTab,
                    tr: indexTabRow,
                    tc: indexTabCol,
                    paIn: partIndex
                },
                dataType: "json",
                success: function(data) {
                    let html = "";

                    if (parseInt($(elementParent).data("tab-row")) >= 0) {
                        html += "<div class=\"el " + DynaCore_FormConfig_Miniform.partClass + "\" data-row=\"" + indexRow + "\" data-col=\"" + indexCol + "\" data-tab=\"" + indexTab + "\" data-tab-row=\"" + indexTabRow + "\" data-tab-col=\"" + indexTabCol + "\" data-part-index=\"" + data.paIn + "\" data-part-id=\"" + data.paId + "\">";
                        html += "    <span class=\"description\">" + translate("Miniform") + "</span>";
                        html += "    <ul class=\"el-" + DynaCore_FormConfig_Form.partName + "-fieldModal-container list-unstyled\"></ul>";
                        html += "    <ul class=\"el-" + DynaCore_FormConfig_Form.partName + "-fieldSection-container list-unstyled\"></ul>";
                        html += "</div>";
                    } else {
                        html += "<div class=\"el " + DynaCore_FormConfig_Miniform.partClass + "\" data-row=\"" + indexRow + "\" data-col=\"" + indexCol + "\" data-part-index=\"" + data.paIn + "\" data-part-id=\"" + data.paId + "\">";
                        html += "    <span class=\"description\">" + translate("Miniform") + "</span>";
                        html += "    <ul class=\"el-" + DynaCore_FormConfig_Form.partName + "-fieldModal-container list-unstyled\"></ul>";
                        html += "    <ul class=\"el-" + DynaCore_FormConfig_Form.partName + "-fieldSection-container list-unstyled\"></ul>";
                        html += "</div>";
                    }

                    $(elementParent).append(html);

                    DynaCore_FormConfig.init();
                    DynaBase_Tabs.init();
                }
            });
        },

        /**
         * Upraveni objektu typu Miniform
         *
         * @param element
         */
        edit: function(element) {
            let partId = $(element).data("part-id");
            let target = DynaBase_Url.getPart(0);
            let targetAlias = DynaBase_Url.getPart(1);
            let url = window.location.href.replace("/form-config/", "/form-config/miniform-edit/") + "?_ch=" + $("#_ch").val() + "&ta=" + target + "&taAl=" + targetAlias + "&paId=" + partId;

            $(document).load(url, function(form) {
                Lemo_Modal
                    .setId("modal-container-formconfig-miniform-edit")
                    .setTitle("Edit miniform")
                    .setContent(form)
                    .setSize("large")
                    .addButton("change", "<i class=\"fas fa-fw fa-check\"></i> " + translate("Change"), "btn btn-primary", function() {
                        $.ajax({
                            type: "post",
                            url: url,
                            data: $("#formConfigMiniform").find(":input").serialize(),
                            dataType: "json",
                            success: function() {
                                let elFieldModalContainer = $(element).find("ul.el-" + DynaCore_FormConfig_Miniform.partName + "-fieldModal-container");
                                let elFieldSectionContainer = $(element).find("ul.el-" + DynaCore_FormConfig_Miniform.partName + "-fieldSection-container");

                                $(elFieldModalContainer).html("");
                                $("#miniforms-fieldsModal").find("> .btn").each(function(i, el) {
                                    $(elFieldModalContainer).append("<li class=\"el el-" + DynaCore_FormConfig_Miniform.partName + "-fieldModal btn btn-sm btn-outline-dark\" data-part-id=\"" + $(el).data("field-id") + "\" data-part-index=\"" + $(el).data("field") + "\">" + $(el).text() + "</li>");
                                });

                                $(elFieldSectionContainer).html("");
                                $("#miniforms-fieldsSection").find("> .btn").each(function(i, el) {
                                    $(elFieldSectionContainer).append("<li class=\"el el-" + DynaCore_FormConfig_Miniform.partName + "-fieldSection btn btn-sm btn-outline-dark\" data-part-id=\"" + $(el).data("field-id") + "\" data-part-index=\"" + $(el).data("field") + "\">" + $(el).text() + "</li>");
                                });

                                Lemo_Alert.addSuccess("Miniform has been successfully updated", "formConfigMinifomrUpdateSuccess");
                                Lemo_Modal.close();
                            },
                            error: function(html) {
                                Lemo_Alert.addDanger("Some form fields are not filled up or not filled correctly", "formConfigMiniformUpdateError");

                                $("#dialogBody").html(html.responseText);
                            }
                        });
                    })
                    .addButton("cancel", "<i class=\"fas fa-fw fa-times\"></i> " + translate("Cancel"), "btn btn-secondary", function() {
                        Lemo_Modal.close();
                    });

                Lemo_Modal.build();

                // Inicializace
                DynaCore_FormConfig_Miniform.editInit();
                DynaCore_FormConfig.fieldsInit("fieldsModal", "miniforms", partId);
                DynaCore_FormConfig.fieldsInit("fieldsSection", "miniforms", partId);
                DynaBase_Tabs.init();
            });
        },

        /**
         * Zmena miniformulare behem upraveni objektu typu Button
         */
        editInit: function() {
            // Zmena miniformulare
            let formConfigMiniform = $("#formConfigMiniform");
            formConfigMiniform
                .off("change", "#modalId")
                .on("change", "#modalId", function() {
                    if (this.value === "") {
                        $("#formConfigMiniform").find(".nav-tabs > li:eq(4)").addClass("d-none");
                    } else {
                        formConfigMiniform.find(".nav-tabs > li:eq(4)").removeClass("d-none");
                        let storageId = formConfigMiniform.find(".tab-content").data("part-id");
                        DynaCore_FormConfig.fieldsLoad(this, "fieldsModal", "miniforms", storageId);
                    }

                    return false;
                });

            const fieldSortingAdd = $(".fieldSortingAdd");
            fieldSortingAdd
                .off("click")
                .on("click", function() {
                    DynaCore_FormConfig_Miniform.fieldSortingAdd(this);
                });

            const fieldSortingDelete = $(".fieldSortingDelete");
            fieldSortingDelete
                .off("click")
                .on("click", function() {
                    DynaCore_FormConfig_Miniform.fieldSortingDelete(this);
                });
        },

        /**
         * Upraveni pole miniformulare
         *
         * @param element
         */
        editField: function(element) {
            let partId = $(element).parents(".tab-content").data("part-id");
            let target = $(element).data("target");
            let fieldIndex = $(element).data("field");
            let url = window.location.href.replace("/form-config/", "/form-config/miniform-edit-field/") + "?_ch=" + $("#_ch").val() + "&parId=" + partId + "&fieInd=" + fieldIndex + "&tar=" + target;

            $(document).load(url, function(form) {
                Lemo_Modal
                    .setId("modal-container-formconfig-miniform-field-edit")
                    .setTitle("Edit miniform field")
                    .setContent(form)
                    .setSize("large")
                    .addButton("change", "<i class=\"fas fa-fw fa-check\"></i> " + translate("Change"), "btn btn-primary", function() {
                        $.ajax({
                            type: "post",
                            url: url,
                            data: $("#formConfigMiniformField").find(":input").serialize(),
                            dataType: "json",
                            success: function() {
                                Lemo_Modal.close();
                            },
                            error: function(html) {
                                Lemo_Alert.addDanger("Some form fields are not filled up or not filled correctly", "formConfigMiniformFieldUpdateError");

                                $("#dialogBody").html(html.responseText);
                            }
                        });
                    })
                    .addButton("cancel", "<i class=\"fas fa-fw fa-times\"></i> " + translate("Cancel"), "btn btn-secondary", function() {
                        Lemo_Modal.close();
                    });

                Lemo_Modal.build();

                DynaBase_Overlay.hide();
            });
        },

        /**
         * Smazani objektu typu Miniform
         *
         * @param element
         */
        delete: function(element) {
            let indexRow = $(element).data("row");
            let indexCol = $(element).data("col");
            let indexTab = $(element).data("tab");
            let indexTabRow = $(element).data("tab-row");
            let indexTabCol = $(element).data("tab-col");
            let partId = $(element).data("part-id");
            let partIndex = $(element).data("part-index");

            Lemo_Modal
                .setId("modal-container-formconfig-miniform-delete")
                .setTitle("Remove miniform")
                .setContent("<p class=\"text\">" + translate("Do you really want to remove selected miniform?") + "</p>")
                .addButton("remove", "<i class=\"fas fa-fw fa-trash\"></i> " + translate("Remove"), "btn btn-danger", function() {
                    $.ajax({
                        type: "get",
                        url: window.location.href.replace("/form-config/", "/form-config/part-delete/"),
                        data: {
                            _ch: $("#_ch").val(),
                            pa: DynaCore_FormConfig_Miniform.partName,
                            r: indexRow,
                            c: indexCol,
                            t: indexTab,
                            tr: indexTabRow,
                            tc: indexTabCol,
                            paIn: partIndex,
                            paId: partId
                        },
                        dataType: "json",
                        success: function() {
                            if ($(element).parent(".card-body").parent(DynaCore_FormConfig_Miniform.partSelector + "-card").length > 0) {
                                element = $(element).parent(".card-body").parent(DynaCore_FormConfig_Miniform.partSelector + "-card");
                            }

                            $(element).remove();

                            DynaCore_FormConfig.reindex();
                        },
                        complete: function() {
                            Lemo_Modal.close();
                        }
                    });
                })
                .addButton("cancel", "<i class=\"fas fa-fw fa-times\"></i> " + translate("Cancel"), "btn btn-secondary", function() {
                    Lemo_Modal.close();
                });

            Lemo_Modal.build();
        },

        fieldSortingAdd: function() {
            let template = $("#form-template-fieldsSorting").data("template");
            let count = $(".fieldSorting").length;

            template = template.replace(/__index__/g, count);

            $("#tab-sorting").find("tbody").append(template);

            DynaCore_FormConfig_Miniform.editInit();
        },

        fieldSortingDelete: function(element) {
            $(element).parents("tr").remove();
        }
    };

